import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';

import { ReferenceBlock } from '../../components/reference-block';

export interface NotionReferenceNodeAttributes {
  url: string;
  name: string;
  type?: string;
}

export const NotionReferenceNode = Node.create({
  name: 'notionReferenceNode',
  type: 'notionReferenceNode',
  group: 'block',
  atom: true,
  inline: false,
  selectable: false,
  draggable: true,

  parseHTML() {
    return [{ tag: 'notion-reference-node' }];
  },
  renderText({ node }) {
    return node.attrs.url;
  },
  renderHTML({ HTMLAttributes }) {
    return ['notion-reference-node', mergeAttributes(HTMLAttributes)];
  },
  addNodeView() {
    return ReactNodeViewRenderer((props) => <ReferenceBlock {...props} source="notion" />);
  },
  addAttributes() {
    return {
      url: {
        default: undefined,
      },
      name: {
        default: undefined,
      },
      type: {
        default: undefined,
      },
    };
  },
});
